module.exports = __webpack_public_path__ + "img/Chevron-Right_16px_Icon-black.59c73f70.svg";